<template>
  <main class="page-operative page-operative-data-analysis page-operative-data-analysis-cogs page-operative-data-analysis-cogs-new">
    <div class="container">
      <div class="d-flex align-items-center justify-content-between mb-5">
        <PageTitle>Nuovo costo proporzionale</PageTitle>
        <app-router-link class="btn btn-outline-primary" :to="{ name: 'operative-company.data-analysis.cogs' }">Torna alla lista</app-router-link>
      </div>

      <FormCostoPerRicavo v-if="company && userCanEdit" :ricavi="ricavi" @saved="saveCosto" />
      <div v-else-if="company">Utente non abilitato</div>
    </div>
  </main>
</template>

<script>

import operativePageMixin from '@/mixins/operativePage';

export default {
  name: 'page-operative-company-data-analysis-cogs-new',
  mixins: [operativePageMixin],
  components: {
    PageTitle: () => import('@/views/components/Layout/LayoutOperative/PageTitle'),
    FormCostoPerRicavo: () => import('@/views/components/Operative/Form/FormCostoPerRicavo'),
    AppRouterLink: () => import('@/views/components/Layout/AppRouterLink'),
  },
  data () {
    return {
      ricavi: [],
    };
  },
  methods: {
    saveCosto (costo) {
      this.$api.addCostoCogs(this.company.id, costo)
        .then(() => {
          this.$router.push({
            name: 'operative-company.data-analysis.cogs',
            query: {
              forecast: this.$route.query?.forecast || null,
            },
          });
        })
        .catch(this.$log.error)
      ;
    },
  },
  watch: {
    company: {
      immediate: true,
      handler: function () {
        if (!this.company) {
          return;
        }

        this.$api.listRicavi(this.company.id)
          .then(res => {
            this.ricavi = res.data.ricavi || [];
          })
          .catch(this.$log.error)
        ;
      },
    },
  },
};

</script>
